import * as React from 'react';
import { Box, Typography } from '@mui/material';
import MobileStepper from '@mui/material/MobileStepper';

export default function DotsMobileStepper(props: any) {
  if (props.stepTitles?.length) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', py: 4 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', width: { xs: '100%', md: '72%' }, px: { xs: 1, md: 0 } }}>
          {props.stepTitles.map((title: string, index: number) => (
            <React.Fragment key={`${title}-${index}`}>
              <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
                <Box sx={{
                  alignItems: 'center',
                  backgroundColor: index <= props.activeStep ? '#2372B9' : '#A8A8A8',
                  borderRadius: '50%',
                  display: 'flex',
                  flex: '0 0 auto',
                  height: 20,
                  justifyContent: 'center',
                  marginRight: 1,
                  width: 20,
                }}>
                  {(props.completedSteps?.[index] || index < props.activeStep) && (
                    <i
                      className="fa-solid fa-check"
                      aria-label="Completed step"
                      style={{ color: '#fff', fontSize: 11 }}
                    />
                  )}
                </Box>
                {title && (
                  <Typography sx={{
                    fontSize: 12,
                    fontWeight: index <= props.activeStep ? 600 : 400,
                    color: index <= props.activeStep ? '#222' : '#777',
                    whiteSpace: 'nowrap',
                  }}>
                    {title}
                  </Typography>
                )}
              </Box>
              {index < props.stepTitles.length - 1 && (
                <Box sx={{ flex: 1, height: '1px', mx: 1.5, backgroundColor: '#D0D0D0' }} />
              )}
            </React.Fragment>
          ))}
        </Box>
      </Box>
    );
  }

  return (
    <MobileStepper
      variant="dots"
      steps={props.steps}
      position="static"
      activeStep={props.activeStep}
      sx={{ maxWidth: '100%', flexGrow: 1, justifyContent: 'center' }}
      nextButton={<></>}
      backButton={<></>}
    />
  );
}
